import { ComponentProps } from 'react';
import Button from '@alltrails/denali/components/Button';

type CreateRouteButtonProps = Pick<ComponentProps<typeof Button>, 'variant'>;

const CreateRouteButton = ({ variant }: CreateRouteButtonProps) => {
  return (
    <Button
      linkInfo={{
        href: '/explore/custom-routes/new?trigger=nav'
      }}
      size="sm"
      text="Create route" // TODO: Translate
      variant={variant}
    />
  );
};

export default CreateRouteButton;
